import { RouteObject } from 'react-router';

import { ROUTES } from '~shared/routes';

export const formsRoutes: RouteObject = {
  children: [
    {
      path: ROUTES.forms.root,
      lazy: async () => {
        const { FormsPage } = await import('../../../pages/forms/Forms.page');

        return { Component: FormsPage };
      },
    },
    {
      path: ROUTES.forms.detail,
      lazy: async () => {
        const { FormPage } = await import('../../../pages/forms/Form.page');

        return { Component: FormPage };
      },
    },
    {
      path: ROUTES.forms.edit,
      lazy: async () => {
        const { FormEditPage } =
          await import('../../../pages/forms/FormEdit.page');

        return { Component: FormEditPage };
      },
    },
  ],
};
